module.exports = __webpack_public_path__ + "img/page-arrow.7c35c2f6.svg";